/*
  Trigger event after animation completes
*/
window.theme.waitForAnimationEnd = function (element) {
  return new Promise((resolve) => {
    if (!element) {
      resolve();
      return;
    }

    const computed = getComputedStyle(element);

    const duration = parseFloat(computed.animationDuration) * 1000;
    const delay = parseFloat(computed.animationDelay) * 1000;
    const iterations = computed.animationIterationCount;

    // Cases with no real animation
    if (computed.display === 'none' || computed.animationName === 'none' || duration === 0 || iterations === 'infinite') {
      resolve();
      return;
    }

    const totalDuration = duration + delay;

    function onAnimationEnd(e) {
      if (e.currentTarget !== element) return;

      element.removeEventListener('animationend', onAnimationEnd);
      clearTimeout(fallback);
      resolve();
    }

    element.addEventListener('animationend', onAnimationEnd);

    // Fallback to avoid stuck Promise
    const fallback = setTimeout(() => {
      element.removeEventListener('animationend', onAnimationEnd);
      resolve();
    }, totalDuration + 50);
  });
};

/*
  Trigger event after all animations complete in a specific section
*/
window.theme.waitForAllAnimationsEnd = function (section) {
  return new Promise((resolve, rejected) => {
    const animatedElements = section.querySelectorAll('[data-aos]');
    let animationCount = 0;

    function onAnimationEnd(event) {
      animationCount++;

      if (animationCount === animatedElements.length) {
        // All animations have ended
        resolve();
      }

      event.target.removeEventListener('animationend', onAnimationEnd);
    }

    animatedElements.forEach((element) => {
      element.addEventListener('animationend', onAnimationEnd);
    });

    if (!animationCount) rejected();
  });
};
